import React from 'react';
import styles from './css/index.module.css';

const AiWardenSummarizePanel = ({ onSubmit, submitting }) => {
    return (
        <>
            <p className={styles.aiWardenTip}>Summarize the currently selected scope (file(s), folder, workstream, or all workstreams).</p>
            <div className={styles.aiWardenAskActions}>
                <button type="button" className={styles.aiWardenPrimaryBtn} onClick={onSubmit} disabled={submitting}>
                    {submitting ? 'Thinking…' : 'Summarize Scope'}
                </button>
                <span className={styles.aiWardenTip}>Summary uses only retrieved context from your selection.</span>
            </div>
        </>
    );
};

export default AiWardenSummarizePanel;
